import { Box, Grid, MenuItem, TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers-pro";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { NO_DRAG_SELECTOR } from "../../../../app/constants";
import { useAppSelector } from "../../../../app/hooks";
import LoadingSpinner from "../../../../common/components/functional/loadingSpinner/LoadingSpinner";
import useIsLoading from "../../../../hooks/useIsLoading";
import LabelCustomInputRow from "../../../customer/contract/form/LabelCustomInputRow";
import { AssignmentById } from "../../../talents/talentAPI";

type Props = {
  assignmentOptions: AssignmentById[];
};

const NewEntryDialogContent = ({ assignmentOptions }: Props) => {
  const { t } = useTranslation();

  const { workTitle } = useAppSelector((state) => state.localized);

  const isLoading = useIsLoading(["talents"]);

  const formatDisplayName = (option: AssignmentById) => {
    const startDate = format(new Date(option.details.start), "dd.MM.yyyy");
    return `${startDate} - ${option.details.workLocationName} - ${workTitle[option.details.workTitleId] || option.details.workTitleId}`;
  };
  return (
    <Grid className={NO_DRAG_SELECTOR} container spacing={2}>
      <LabelCustomInputRow
        fieldName="startDate"
        label={t("hourEntries:dateLong")}
        labelWidth={2}
        inputWidth="auto"
        render={(field) => (
          <DesktopDatePicker
            {...field}
            value={field.value}
            format="dd.MM.yyyy"
            onChange={(newDate: Date | null) => field.onChange(newDate)}
            slotProps={{
              textField: {
                InputProps: { sx: { height: "32px" } },
                size: "small",
                fullWidth: true,
              },
            }}
          />
        )}
      />
      <LabelCustomInputRow
        fieldName="assignmentId"
        inputWidth={12}
        render={(field) => (
          <TextField
            select
            size="small"
            fullWidth
            value={field.value}
            onChange={field.onChange}
            sx={{ width: "568px" }}
            SelectProps={{ sx: { height: "32px" } }}
          >
            {isLoading ? (
              <MenuItem disabled>
                <Box
                  display="flex"
                  alignItems="center"
                  position="relative"
                  width="100%"
                >
                  <LoadingSpinner />
                </Box>
              </MenuItem>
            ) : assignmentOptions.length === 0 ? (
              <MenuItem disabled>{t("common:noOptions")}</MenuItem>
            ) : (
              assignmentOptions.map((option) => (
                <MenuItem key={option.assignmentId} value={option.assignmentId}>
                  {formatDisplayName(option)}
                </MenuItem>
              ))
            )}
          </TextField>
        )}
      />
    </Grid>
  );
};

export default NewEntryDialogContent;
